// Soot that blasts and beams leave on whatever they hit. Characters get burn
// decals instead. Visual only.
import * as PIXI from 'pixi.js';
import { segmentHit } from './surfaceField';
import { paintStamp } from './surfacePaint';

const BLAST_RAYS = 16;
let soot = null;

// `size` is in screen pixels; the soot's streaks run along `angle`.
export const scorch = (body, x, y, size, angle, alpha) => {
	if (!body || body.destroyed || body.isFlesh) return;
	soot = soot || PIXI.Texture.from('skorch.png');
	paintStamp(body, x, y, {texture: soot, size, angle, alpha});
};

// Rays out from a blast at (x, y), in metres, soot where they land: bigger and
// darker close by. `ignore` is the body that blew up.
export const scorchBlast = (x, y, radius, pixels, ignore) => {
	const turn = Math.random() * Math.PI * 2;
	for (let i = 0; i < BLAST_RAYS; i++) {
		const angle = turn + i * Math.PI * 2 / BLAST_RAYS;
		const hit = segmentHit(x, y, x + Math.cos(angle) * radius, y + Math.sin(angle) * radius);
		if (!hit || hit.body === ignore) continue;
		const near = 1 - hit.t;
		scorch(hit.body, hit.x, hit.y, pixels * (0.3 + 0.7 * near) * (0.8 + Math.random() * 0.4), angle + (Math.random() - 0.5) * 0.6, 0.25 + 0.4 * near);
	}
};
